<template lang="pug">
#content
    unit(v-bind:sidebar="sidebar")
    .content
        router-view
    site-footer
</template>

<script>
import Vue from 'vue'
import unit from './sidebar/unit.vue'
import GeneralTitle from './setting/component/general-title.vue'
Vue.component('general-title', GeneralTitle)

const visitorLinks = [
  {
    to: '/web/geodistrib',
    name: '访客地域'
  },
  {
    to: '/web/attributes',
    name: '人群属性'
  },
  {
    to: '/web/generation',
    name: '新老访客'
  },
  {
    to: '/web/client',
    name: '客户端信息'
  }
]
if (window.$isDjPlatform) {
  visitorLinks.push({
    to: '/web/visitInfo',
    isNew: true,
    name: '访客细查'
  })
}

export default {
  data () {
    return {
      sidebar: [
        {
          title: '概览',
          iconName: 'globe',
          iconColor: '#73ace6',
          expanded: true,
          focused: false,
          links: [
            {
              to: '/web/overview',
              name: '网站概况'
            },
            {
              to: '/web/realtime',
              name: '实时数据'
            },
            {
              to: '/web/flux',
              name: '流量趋势'
            }
          ]
        },
        {
          title: '流量来源',
          iconName: 'tint',
          iconColor: '#ae84a7',
          expanded: true,
          focused: false,
          links: [
            {
              to: '/web/origin',
              name: '来源分析'
            },
            {
              to: '/web/keyword',
              name: '搜索词分析'
            },
            {
              to: '/web/risefall',
              name: '升降榜'
            }
          ]
        },
        {
          title: '推广分析',
          iconName: 'align-left',
          iconColor: '#54c08a',
          expanded: true,
          focused: false,
          links: [
            {
              to: '/web/overall',
              name: '推广概览'
            },
            {
              to: '/web/promotion',
              name: '搜索推广'
            },
            {
              to: '/web/optimizeaccount',
              isNew: true,
              name: '账户优化'
            },
            {
              to: '/web/addisplay',
              name: '展示广告'
            }
          ]
        },
        {
          title: '访客分析',
          iconName: 'book',
          iconColor: '#e8b71a',
          expanded: true,
          focused: false,
          links: visitorLinks
        },
        {
          title: '站内分析',
          iconName: 'adjust',
          iconColor: '#6dc6cd',
          expanded: true,
          focused: false,
          links: [
            {
              to: '/web/page',
              name: '页面分析'
            },
            {
              to: '/web/heatlist',
              name: '热力图'
            },
            {
              to: '/web/associate',
              name: '关联页分析'
            },
            {
              to: '/web/subdir',
              name: '子目录'
            },
            {
              to: '/web/path',
              name: '路径分析'
            },
            {
              to: '/web/conversion',
              name: '转化分析'
            }
          ]
        },
        {
          title: '行业分析',
          iconName: 'briefcase',
          iconColor: '#f46800',
          expanded: true,
          focused: false,
          links: [
            {
              to: '/web/sites',
              name: '浏览网站'
            },
            {
              to: '/web/search',
              name: '搜索分析'
            }
          ]
        }
      ]
    }
  },
  components: {
    unit
  }
}
</script>



// WEBPACK FOOTER //
// web.vue?092dd432